import { resetSelectedBookable, setTreatment, useChoiceDispatch, useChoiceState } from '@context/ChoiceContext'
import { setClinicId, useConfig, useConfigDispatch } from '@context/ConfigurationContext'
import {
  clearPractitioners,
  resetSelectedPractitionersFor,
  usePractitionersDispatch,
} from '@context/PractitionersContext'
import { CategorizedTreatmentsWithPartialTreatments } from '@customTypes/CategorizedTreatment'
import { useMakeAdditionalActionIfChildProphylaxis } from './useMakeAdditionalActionIfChildProphylaxis'

export const useSelectTreatmentForManyClinics = (
  onFinishCallback: () => void,
  categorizedTreatments: CategorizedTreatmentsWithPartialTreatments[]
) => {
  const { treatmentBundleTypeReferenceId } = useChoiceState()
  const choiceDispatch = useChoiceDispatch()
  const configDispatch = useConfigDispatch()
  const practitionersDispatch = usePractitionersDispatch()
  const makeAdditionalActionIfChildProphylaxis = useMakeAdditionalActionIfChildProphylaxis()
  const { clinicId } = useConfig()
  const flatTreatments = categorizedTreatments?.flatMap((category) => category.treatmentBundles) || []

  return (id: string) => {
    choiceDispatch(setTreatment(id))

    if (treatmentBundleTypeReferenceId !== id) {
      const selectedTreatment = flatTreatments.find((treatment) => treatment.referenceId === id)
      const treatmentsInClinic = flatTreatments.filter((treatment) => treatment.clinicReferenceId === clinicId)
      const selectedTreatmentInSelectedClinic =
        !!clinicId &&
        treatmentsInClinic.find(
          (treatment) => treatment.treatmentPurposeReferenceId === selectedTreatment?.treatmentPurposeReferenceId
        )
      if (selectedTreatmentInSelectedClinic && selectedTreatmentInSelectedClinic.referenceId) {
        choiceDispatch(setTreatment(selectedTreatmentInSelectedClinic.referenceId))
      }

      const shouldResetClinic = !!clinicId && !selectedTreatmentInSelectedClinic

      makeAdditionalActionIfChildProphylaxis(selectedTreatment?.treatmentPurposeReferenceId)
      practitionersDispatch(clearPractitioners())
      practitionersDispatch(resetSelectedPractitionersFor())
      choiceDispatch(resetSelectedBookable())
      if (shouldResetClinic) {
        configDispatch(setClinicId(''))
      }
    }

    onFinishCallback()
  }
}
